import { i18n } from "@lingui/core";
import { usePulseTracking } from "src/utils/pulseHelper.ts";
import { useAppConfig } from "../../context/AppConfigProviderContext.tsx";
import { TabId } from "../../utils/tabs.ts";
import "./navigationBar.css";

export const NavigationBar = ({
  activeTab,
  setActiveTab,
}: {
  activeTab: TabId;
  setActiveTab: (tab: TabId) => void;
}) => {
  const { tabs } = useAppConfig();
  const { trackNavigationClick } = usePulseTracking();

  if (tabs.length <= 1) {
    return null;
  }

  const labels: Record<TabId, string> = {
    [TabId.AboutUs]: i18n.t({ id: "dealerBrandingLayout.tabs.aboutUs.label", message: "About us" }),
    [TabId.Campaigns]: i18n.t({ id: "dealerBrandingLayout.tabs.campaigns.label", message: "Campaigns" }),
    [TabId.DealerAds]: i18n.t({ id: "dealerBrandingLayout.tabs.listings.label", message: "Listings" }),
    [TabId.ImageGallery]: i18n.t({ id: "dealerBrandingLayout.tabs.imageGallery.label", message: "Our dealership" }),
    [TabId.Employees]: i18n.t({ id: "dealerBrandingLayout.tabs.employees.label", message: "Employees" }),
    [TabId.OtherLocations]: i18n.t({
      id: "dealerBrandingLayout.tabs.otherLocations.label",
      message: "Other locations",
    }),
  };

  return (
    <>
      <div className="tabs-wrapper sticky tabs-z-15 top-[50] s-bg">
        <div className="page-container">
          <div className="tabs border-b">
            <div className="inline-grid relative grid-flow-col auto-cols-max gap-20">
              {tabs.map((tab) => (
                <a
                  key={tab}
                  className={`grid border-b-4 border-transparent md:hover:s-border-primary font-bold px-12 pt-[7px] pb-8 md:hover:s-text-link focus:no-underline hover:no-underline ${
                    tab === activeTab ? "s-border-selected s-text-link" : "s-text-subtle"
                  }`}
                  href={`#${tab}`}
                  onClick={() => {
                    trackNavigationClick(tab, `#${tab}`);
                    setActiveTab(tab);
                    history.replaceState(undefined, "", `#${tab}`);
                  }}
                >
                  {labels[tab]}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
